module.exports = __webpack_public_path__ + "img/icon6.9fc8c7b1.svg";